/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'

// Import views
import LandingHome from '../views/LandingHome.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import ConfirmRegistration from '../views/ConfirmRegistration.vue'
import SecureHome from '../views/SecureHome.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ResendCode from '../views/ResendCode.vue'
import UserData from '../views/UserData.vue'

// Import Auth module
import {
  Auth
} from 'aws-amplify'

Vue.use(VueRouter)

// Set up global guards TO secureHome or any other ones you'd like to secure
async function isLoggedIn(to, from, next) {
  // If our route requires auth, we need to check.
  if (to.meta.requireAuth) {
    // Call the Auth module, check if there's a user. If not, send to login
    try {
      let user = await Auth.currentAuthenticatedUser()

      if (user) {
        next()
      } else {
        next({
          path: '/login'
        })
      }
    } catch (e) {
      next({
        path: '/login'
      })
    }
  }
}


const routes = [{
    path: '/',
    name: 'LandingHome',
    component: LandingHome,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/confirmRegistration',
    name: 'ConfirmRegistration',
    component: ConfirmRegistration,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/secureHome',
    name: 'SecureHome',
    component: SecureHome,
    // Before entering the route, fire off isLoggedIn
    // to check the user is authenticated
    beforeEnter: isLoggedIn,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/myprofile',
    name: 'UserData',
    component: UserData,
    beforeEnter: isLoggedIn,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/resendCode',
    name: 'ResendCode',
    component: ResendCode,
    meta: {
      requireAuth: false
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router